import * as React from 'react';
import { useLocalStorage } from 'react-use';

import { NotificationVersionData } from '../types';

type NotificationStorageHookResult = [boolean, () => void];

export const createNotificationStorageHook =
  (key: string) =>
  (version: string): NotificationStorageHookResult => {
    const [storedVersion, setSeenVersion] = useLocalStorage<NotificationVersionData>(key, {
      version: '0',
      seen: true,
    });

    React.useEffect(() => {
      if (version !== storedVersion?.version) {
        setSeenVersion({
          version,
          seen: false,
        });
      }
    }, []);

    const setSeenCurrentNotification = React.useCallback(() => {
      setSeenVersion({
        version,
        seen: true,
      });
    }, [setSeenVersion, version]);

    return [Boolean(storedVersion?.seen), setSeenCurrentNotification];
  };
